import type { FC } from "preact/compat";
import type { IconButtonProps } from "./interfaces";
import cn from "classnames";

const IconButton: FC<IconButtonProps> = ({
    title,
    onClick,
    children,
    className,
    disabled,
    flat,
    size = "md",
    ...props
}) => (
    <button
        type="button"
        title={title}
        onClick={onClick}
        disabled={disabled}
        className={cn(
            "rounded-full fill-current outline-none",
            "hover:border-sky-300 hover:text-sky-500 focus:ring focus:ring-sky-300",
            "disabled:focus:ring-none disabled:text-gray-400 disabled:hover:border-gray-200 disabled:hover:text-gray-400",
            !flat && "border border-gray-300 bg-white",
            !flat && size === "md" && "p-2",
            !flat && size === "sm" && "p-1",
            className,
        )}
        {...props}
    >
        {children}
    </button>
);

export default IconButton;
